import React from 'react';

import cn from 'classnames';

import { IMessageAttachment } from '@entities/message/model/types';
import { Flex } from '@shared/ui';

import { ImageAttachments } from './ImageAttachments';
import { MessageAttachment } from './MessageAttachment';
import cls from './MessageAttachments.module.css';

interface IMessageAttachmentsProps {
    className?: string;
    imgAttachments?: IMessageAttachment[];
    otherAttachments?: IMessageAttachment[];
    onOpenAttachments?: (
        attachments: IMessageAttachment[],
        currentAttachmentId: IMessageAttachment['id']
    ) => void;
}

export const MessageAttachments = ({
    className,
    imgAttachments,
    otherAttachments,
    onOpenAttachments,
}: IMessageAttachmentsProps) => (
    <Flex
        className={cn(cls.MessageAttachments, className)}
        direction="column"
        gap={10}
        justify="start"
        align="start"
        fullWidth
    >
        {imgAttachments?.length > 0 && (
            <ImageAttachments
                imgAttachments={imgAttachments}
                onOpenAttachments={onOpenAttachments}
            />
        )}
        {otherAttachments?.length > 0 && (
            <Flex className={cls.OtherAttachments} direction="column" gap={10}>
                {otherAttachments?.map((attachment) => (
                    <MessageAttachment
                        key={attachment.id}
                        attachment={attachment}
                        attachments={otherAttachments}
                        onOpenAttachments={onOpenAttachments}
                    />
                ))}
            </Flex>
        )}
    </Flex>
);
